/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=c52f2b20&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/EDUMGD/PRODUCT/FRONTEND-DEPLOY/teach-webs/szpx/szpx-ci/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c52f2b20"]])

export default __exports__